import { useParams } from 'react-router-dom';
import { EventQuery } from 'queries';

function useDetail() {
  const { id } = useParams<{ id: string }>();
  const { data: event } = EventQuery.useGet(id || '');

  return { event };
}

export default useDetail;
